import { render, staticRenderFns } from "./HistoricoEstadoCadastral.vue?vue&type=template&id=322b7886"
import script from "./HistoricoEstadoCadastral.vue?vue&type=script&lang=js"
export * from "./HistoricoEstadoCadastral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports